import React, { useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import dictionary from "../../util/dictionary";
const UserWelcomeCard = () => {
  const { user } = useContext(AuthContext);
  return (
    <div>
      <div className="col-sm-12 col-lg-12 col-md-12 col-xl-12">
        <div
          className="card custom-card card-box"
          style={{
            background:
              "linear-gradient(135deg, #37d4cc, #5098c8ff, #043949ff, #011f29ff)",
            // background: "linear-gradient(135deg, #D4AF37, #800020, #2C3E50)",
            color: "white",
            borderRadius: "15px",
            boxShadow: "0 20px 25px rgba(0, 0, 0, 0.3)",
          }}
        >
          <div className="card-body p-4">
            <div className="row align-items-center">
              <div className="offset-xl-3 offset-sm-6 col-xl-8 col-sm-6 col-12 ">
                <h4 className="d-flex mb-3">
                  <span className="font-weight-bold text-white">
                    {user.first_name + " " + user.last_name}
                  </span>
                </h4>
                <p className="tx-white-720 mb-1">
                  📦 Welcome to your Procurement Management Dashboard! 🧾 <br />
                  Remember, you're not just tracking orders—you're optimizing
                  resources, ensuring transparency, and driving operational
                  efficiency. 🛠️ Keep up the excellent work, and let's continue
                  building a seamless and reliable supply chain! 📊
                </p>
              </div>
              <img
                style={{
                  borderRadius: "50%",
                  marginTop: "-80px",
                  marginLeft: "15px",
                  padding: "2px",
                  width: "160px",
                  height: "160px",
                  borderBottom: "3px solid #D4AF37", // Metallic Gold
                  borderLeft: "5px solid #800020", // Burgundy (luxury crimson)
                  borderTop: "6px solid #1d799bff", // Deep Indigo/Charcoal Grey
                }}
                src={`${dictionary.apiHost}/img/avatar.png`}
                alt="user-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserWelcomeCard;
